import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { BankAccountTransactionService } from '../../../services/BankAccountTransactionService';
import { GetBankAccountTransactionListPagingAndFilterRequest, initialGetBankAccountTransactionListPagingAndFilterRequest } from '../../../models/request/bankAccountTransaction/GetBankAccountTransactionListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetBankAccountTransactionListPagingAndFilterResponse, GetBankAccountTransactionListPagingAndFilterResponseData, GetBankAccountTransactionListPagingAndFilterResponseItem, initialGetBankAccountTransactionListPagingAndFilterResponseData } from '../../../models/response/bankAccountTransaction/GetBankAccountTransactionListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import Box from '../../../components/Box';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import BankAccountTransactionListFilters from './Components/BankAccountTransactionListFilters';
import BankMovementPopUp from '../../../components/BankMovementPopUp';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadConstantsByCode } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ExportBankAccountTransactionListResponse } from '../../../models/response/bankAccountTransaction/ExportBankAccountTransactionListResponse';

// Hareket Tipi: veritabanında "A" Tahsilat, "B" Ödeme (BankAccountTransactionManager.ApplyColumnFilters).
const debtOrReceivableOptions = (): Promise<ColumnFilterOption[]> => Promise.resolve([
    { value: 'A', label: 'Tahsilat' },
    { value: 'B', label: 'Ödeme' },
])

const BankAccountTransactionList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Ön Muhasebe > İşlemler > Banka Hareketleri"
    const pageVersion = "2";
    const [data, setData] = useState<GetBankAccountTransactionListPagingAndFilterResponseData>(initialGetBankAccountTransactionListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetBankAccountTransactionListPagingAndFilterRequest>(initialGetBankAccountTransactionListPagingAndFilterRequest)
    const [selectedItem, setSelectedItem] = useState<GetBankAccountTransactionListPagingAndFilterResponseItem | undefined>(undefined);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'İşlem Türü', name: 'matchType', order: 0, isVisible: true },
            { title: 'Hareket Tipi', name: 'debtOrReceivableText', order: 0, isVisible: true },
            { title: 'Banka', name: 'bankName', order: 0, isVisible: true },
            { title: 'İlgili Hesap', name: 'relatedAccount', order: 0, isVisible: true },
            { title: 'Tutar', name: 'amount', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Döviz Cinsi', name: 'currencyTypeName', order: 0, isVisible: true },
            { title: 'İşlem Tarihi', name: 'transactionDateStr', order: 0, isVisible: true },
            { title: 'Açıklama', name: 'description', order: 0, isVisible: true },
            { title: 'Transaction Id', name: 'transactionId', order: 0, isVisible: false },
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteBankAccountTransaction = async () => {
        // try {
        //     var selectedIds = data.items.filter(x => x.isSelected).map(x => x.bankAccountTransactionId);

        //     dispatch(storeActivityIndicator(true))

        //     var response: DeleteBankAccountTransactionResponse = await BankAccountTransactionService.deleteBankAccountTransaction(selectedIds);

        //     if (!response.isSuccess) {
        //         toast.error(response.message)
        //         dispatch(storeActivityIndicator(false))
        //         return;
        //     }

        //     toast.success(response.message)

        //     getData();
        // } catch (error: any) {
        //     toast.error(error)
        //     dispatch(storeActivityIndicator(false))
        // }
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetBankAccountTransactionListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetBankAccountTransactionListPagingAndFilterResponse = await BankAccountTransactionService.getBankAccountTransactionListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            // Bu ekranda satır seçimi yok: "Seçilenler" gösterilmez (allowSelected={false}).
            var response: ExportBankAccountTransactionListResponse = await BankAccountTransactionService.exportBankAccountTransactionList(buildExcelRequest(filter, mode, [], columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Bellekte hesaplananlar (işlem türü,
    // hareket tipi metni, ilgili hesap) listede yok.
    const sortableColumns = [
        'bankName', 'amount', 'currencyTypeName',
        'transactionDateStr', 'description', 'transactionId'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (BankAccountTransactionManager.ApplyColumnFilters) aynı. İşlem Türü eşleşme
    // kayıtlarından hesaplandığı için filtresiz.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        debtOrReceivableText: { type: 'select', allowEmpty: false, loadOptions: debtOrReceivableOptions, renderOption: (label) => <StatusBadge text={label} /> },
        bankName: { type: 'select', loadOptions: () => loadConstants('BANK') },
        // Firma, banka hesabı ya da kasa adı (eski paneldeki Firma filtresi).
        relatedAccount: { type: 'text' },
        amount: { type: 'number' },
        currencyTypeName: { type: 'select', loadOptions: () => loadConstantsByCode('CURRENCY') },
        transactionDateStr: { type: 'date' },
        description: { type: 'text' },
        transactionId: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetBankAccountTransactionListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "matchType") {
            return (
                <td>
                    {
                        item.isMatch && (
                            <Box flexDirection='row'>
                                <Box justifyContent='center'>
                                    <i style={{ color: '#88d684' }} className="fa fa-check-circle"></i>
                                </Box>
                                <Box ml='5px' justifyContent='center'>
                                    <a onClick={() => setSelectedItem(item)} className='actionIcon' style={{ textDecoration: 'underline', color: '#88d684' }}>{item.matchType}</a>
                                </Box>
                            </Box>
                        )
                    }

                    {
                        !item.isMatch && (
                            <Box flexDirection='row'>
                                <Box justifyContent='center'>
                                    <i style={{ color: '#999593' }} className="fa fa-question-circle"></i>
                                </Box>
                                <Box ml='5px' justifyContent='center'>
                                    <a onClick={() => setSelectedItem(item)} className='actionIcon' style={{ textDecoration: 'underline', color: '#999593' }}>{item.matchType}</a>
                                </Box>
                            </Box>
                        )
                    }
                </td>
            )
        }
        else if (column == "bankName") {
            return (
                <td style={{ width: 1 }} className={className}>
                    <img style={{ maxWidth: 75 }} className="actionIcon img img-thumbnail" src={item.bankLogo ? item.bankLogo : Helpers.getPlaceholder()} />
                </td>
            )
        }
        else if (column == "debtOrReceivableText") {
            return <td className={className}><StatusBadge text={item.debtOrReceivableText} /></td>;
        }
        else if (['amount'].includes(column)) {
            var item2: any = item;
            return <td className={className}>{Helpers.correctPrice(item2[column], 2)}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className}>{item2[column]}</td>;
        }
    }

    // Dip toplam: görüntülenen sayfadaki kayıtların toplamı. Banka hesabının para birimi
    // kayıttan kayda değişebildiği için tutar döviz bazında gelir ("1.250,00 TRY, 45,00 USD");
    // her döviz alt alta yazılır. Diğer kolonlar boş bırakılır.
    const getTotalValue = (columnName: string, columnIndex: number, className: string | undefined) => {
        const totals = data.totals;

        if (columnIndex == 0) {
            return <td className={className}>Toplam</td>;
        }

        if (columnName == 'amount') {
            var text = totals?.amount ?? '';

            return (
                <td className={className}>
                    {text.split(', ').filter(x => x != '').map(x => <div>{x}</div>)}
                </td>
            );
        }

        return <td className={className}></td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <BankAccountTransactionListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table ebbe-table-fill'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={0}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                    {
                                        /* Az kayıt geldiğinde kalan boşluğu doldurur; dip toplam satırı
                                           tablonun altına iner, çerçeve hep aynı yerde kalır. */
                                        data.items.length > 0 && (
                                            <tr className="ebbe-table-filler">
                                                <td colSpan={99}></td>
                                            </tr>
                                        )
                                    }
                                </tbody>

                                {
                                    data.items.length > 0 && (
                                        <tfoot>
                                            <tr>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>

            {
                selectedItem && (
                    <BankMovementPopUp
                        customCallback={getData}
                        selectedItem={selectedItem}
                        setSelectedItem={setSelectedItem}
                    />
                )
            }
        </React.Fragment>
    )
}

export default BankAccountTransactionList;